import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { useProxiedRef } from '../../../utils/hooks/useProxiedRef.js';
import { Column } from '../util/renderColumn.js';

var _excluded = ["autoFocus", "children", "disableSorting", "headerGroups", "headerRef", "bodyRef"];
var DefaultEmptyState = function DefaultEmptyState() {
  return null;
};
var BaseTable = /*#__PURE__*/React__default.forwardRef(function BaseTable(props, ref) {
  var tableRef = useProxiedRef(ref);

  var autoFocus = props.autoFocus,
      children = props.children,
      headerGroups = props.headerGroups,
      headerRef = props.headerRef,
      bodyRef = props.bodyRef,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  React__default.useEffect(function () {
    if (autoFocus && tableRef.current) {
      tableRef.current.focus();
    }
  }, []);
  var className = cn('yt-table', props.className);
  return React__default.createElement("div", Object.assign({}, otherProps, {
    role: "table",
    className: className,
    ref: tableRef
  }), React__default.createElement("div", {
    role: "rowgroup",
    className: "yt-table__head",
    ref: headerRef
  }, headerGroups === null || headerGroups === void 0 ? void 0 : headerGroups.map(function (headerGroup, index) {
    return React__default.createElement("div", {
      key: index,
      role: "row",
      className: "yt-table__row"
    }, headerGroup.headers.map(function (cell, index) {
      return React__default.createElement(Column, {
        key: index,
        index: index,
        cell: cell
      });
    }));
  })), React__default.createElement("div", {
    role: "rowgroup",
    className: "yt-table__body",
    ref: bodyRef
  }, children));
});

export { BaseTable, DefaultEmptyState };
//# sourceMappingURL=BaseTable.js.map
